module.exports = __webpack_public_path__ + "static/img/GP.b8f32c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/GP.png
// module id = 2i8h
// module chunks = 0